import React from 'react';
import DataTables from 'components/dataTables';
import { connect } from 'react-redux';
import { CampaignAction } from 'redux/actions';
import TableCustomHeader from 'components/dataTables/tableCustomHeader';
import { Button } from 'reactstrap';
import PopupWindow from 'components/ModalPopup';
import PageSpinner from 'components/PageSpinner';
import { DateFormat, checkPermissions } from 'hooks';
import { MdModeEdit, MdDelete } from 'react-icons/md';
import AddInterestForm from './add';
const Interest = (props) => {

    const [isDelete, setIsDelete] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [pagination, setPagination] = React.useState({
        page: 0,
        page_limit: 10,
    });
    const [order, setOrder] = React.useState({

        order_by: `created_at`,
        direction: 'desc'

    });
    let [selectedInterest, setSelectedInterest] = React.useState({});



    React.useEffect(() => {
        let payload = {
            page: pagination.page,
            page_limit: pagination.page_limit,
            order_by: order.order_by,
            direction: order.direction
        };
        props.getInterest(payload);
    }, [pagination, order])

    React.useEffect(() => {
        let payload = {
            page: pagination.page,
            page_limit: pagination.page_limit,
            order_by: order.order_by,
            direction: order.direction
        };
        props.getInterest(payload);
        setOpen(false);
    }, [props.interestSaved, props.interestDeleted])

    const columns = () => {
        const cols = [
            { name: "id", label: "Id" },
            { name: "name", label: "Name" },
            { name: "created_at", label: "Created" },
            { name: "updated_at", label: "Last Updated" },
            { name: "action", label: "Action" },
            { name: "campaigns_count", label: "campaigns_count" },

        ];
        return cols.map((column, index) => {
            return {
                label: column.label,
                name: column.name,
                options: {
                    display: (column.name === 'id' || column.name === 'campaigns_count') ? false : true,
                    customHeadRender: (columnMeta, updateDirection) => {
                        return <TableCustomHeader key={index} itemkey={index} order={order} columnMeta={columnMeta} updateDirection={updateDirection} />
                    },
                    customBodyRender: (value, tableMeta, updateValue) => {

                        
                        return (column.name === 'created_at' || column.name === 'updated_at') ? DateFormat(value) :
                            (column.name === 'action') ? <div>
                                {checkPermissions(props.loginData, 'campaign_interests_update') ?
                                    <MdModeEdit onClick={() => handleEdit(tableMeta.rowData)} size={25} style={{ borderRadius: 5, border: '1px solid', cursor: 'pointer', color: '#00aee4', marginLeft: 10 }} />
                                    : <MdModeEdit className={'disabled'} size={25} style={{ borderRadius: 5, border: '1px solid', cursor: 'pointer', color: '#00aee4', marginLeft: 10 }} />
                                }

                                { (checkPermissions(props.loginData, 'campaign_interests_delete') && tableMeta.rowData[5] === 0) ?
                                    <MdDelete onClick={() => handleDelete(tableMeta.rowData)} size={25} style={{ borderRadius: 5, border: '1px solid', cursor: 'pointer', color: '#fc5c7d', marginLeft: 10 }} />
                                    : <MdDelete className={'disabled'} size={25} style={{ borderRadius: 5, border: '1px solid', cursor: 'pointer', color: '#fc5c7d', marginLeft: 10 }} />
                                }


                            </div>
                                : value
                    },
                    setCellProps: () => ({
                        style: (column.name === 'action') ? { maxWidth: "50px" } :{ width: 'auto' }
                    }),
                }
            }
        })
    }

    const options = {
        tableId: 'datatable',
        filterType: 'checkbox',
        search: false,
        responsive: "simple",
        filter: false,
        download: false,
        print: false,
        selectableRows: 'none',
        viewColumns: false,
        count: props.totalCount,
        serverSide: (props.serverSide !== undefined) ? props.serverSide : true,
        page: pagination.page,
        rowsPerPage: pagination.page_limit,
        onColumnSortChange: (changedColumn) => {
            setOrder({
                order_by: changedColumn,
                direction: (order.direction === 'asc') ? 'desc' : 'asc'
            })
        },
        onTableChange: (action, tableState) => {
            switch (action) {
                case 'changePage':
                    setPagination({
                        page_limit: pagination.page_limit,
                        page: tableState.page
                    })
                    break;
                case 'changeRowsPerPage':
                    setPagination({
                        page_limit: tableState.rowsPerPage,
                        page: 0,
                    })
                    break;
                default:
                    break
            }
        }
    };



    const handlePopup = (status) => {
        setIsDelete(false);
        setOpen(status);
        setSelectedInterest({});
    }

    const handleEdit = (rowData) => {
        setIsDelete(false);
        setSelectedInterest(rowData)
        setOpen(true);
    }

    const handleDelete = (rowData) => {
        setIsDelete(true);
        setSelectedInterest(rowData)
        setOpen(true);
    }

    return (
        <div>

            <PopupWindow
                hideButton={!checkPermissions(props.loginData, 'campaign_interests_add')}
                handlePopup={handlePopup}
                openWindow={open}
                title={(selectedInterest && selectedInterest[0] && isDelete) ?'Delete Interest':(selectedInterest && selectedInterest[0])?'Edit Interest' : 'Add New Interest'}
                btnClass={'add-new-charge'}
                launchButtonText={'Add New Interest'} buttonStyle={{ display: 'block', marginLeft: 'auto', marginBottom: '10px' }}>

                {isDelete ?
                    <div>
                        <div>
                            Are you sure? Do you want to delete this interest?
                        </div>
                        <div style={{ display: 'flex' }}>
                            <Button
                                style={{ padding: 'auto', width: 100, marginTop: 20, marginRight: 10 }}
                                size="sm"
                                onClick={() => {
                                    props.deleteInterest({ id: selectedInterest[0]});
                                }}
                                block >
                                Yes
                            </Button>
                            <Button
                                color="primary"
                                style={{ padding: 'auto', width: 100, marginTop: 20 }}
                                size="sm"
                                onClick={() => setOpen(false)}
                                block >
                                No
                            </Button>
                        </div>
                    </div>
                    : <AddInterestForm selectedInterest={selectedInterest} />
                }
            </PopupWindow>



            {props.isLoading ? <PageSpinner />
                : <DataTables data={props.interestsList} columns={columns()} options={options} />
            }
        </div>
    );
}



export default connect(
    (state) => ({

        loginData: (state.loginReducer && state.loginReducer.loginData && state.loginReducer.loginData.user) ? state.loginReducer.loginData.user : null,
        isLoading: (state.uiReducer && state.uiReducer.isLoading) ? state.uiReducer.isLoading : false,
        interestsList: (state.campaign &&
            state.campaign.interests &&
            state.campaign.interests.data) ? state.campaign.interests.data : [],
        totalCount: (state.campaign && state.campaign.interests &&
            state.campaign.interests.total) ? state.campaign.interests.total : 0,
        interestSaved: (state.campaign && state.campaign.interestSaved) ? state.campaign.interestSaved : undefined,
        interestDeleted: (state.campaign && state.campaign.interestDeleted) ? state.campaign.interestDeleted : undefined,

    }),
    (dispatch) => ({
        getInterest: (payload) => dispatch(CampaignAction.getInterest(payload)),
        saveInterest: (payload) => dispatch(CampaignAction.saveInterest(payload)),
        deleteInterest: (payload) => dispatch(CampaignAction.deleteInterest(payload)),
    })

)(Interest);